import { UaopFlags } from '../beneficiaries/fileUploadPages/DryRunDialog';
import { CountrySpecificType, DefaultValueType, SupportedCountries } from './types';

type ConfirmationTypeToCustomValueMapping = {
    [key in UaopFlags]: CountrySpecificType<string> & DefaultValueType<string>;
};

export const customUaopFileExampleMapping: ConfirmationTypeToCustomValueMapping = {
    [UaopFlags.IncrementalAnyAmount]: {
        customPerCountry: {
            [SupportedCountries.syr_gos]:
                'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_incremental_any_amount_syr_gos.html',
        },
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_incremental_any_amount.html',
    },
    [UaopFlags.IncrementalAnyAmountWithPreviousCheck]: {
        default: '',
    },
    [UaopFlags.IncrementalAnyAmountWithAllowedOverlap]: {
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_incremental_intended_assistance_overlap.html',
    },
    [UaopFlags.IncrementalDeltaAmountV2]: {
        customPerCountry: {
            [SupportedCountries.syr_gos]:
                'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_incremental_delta_amount_v2_syr_gos.html',
        },
        default: '',
    },
    [UaopFlags.TotalDeltaAmountV2]: {
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_total_delta_amount_v2.html',
    },
    [UaopFlags.IncrementalShiftPeriodV2]: {
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_incremental_shift_period_v2.html',
    },
    [UaopFlags.TotalAnyAmount]: {
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_total_any_amount.html',
    },
    [UaopFlags.AssistanceOverlapSkip7]: {
        default: 'https://wfp-public.s3.eu-central-1.amazonaws.com/UAOP_assistance_overlap_skip_7.html',
    },
    [UaopFlags.NoneHistorical]: {
        default: '',
    },
    [UaopFlags.NoneIntendedAssistanceOverlap]: {
        default: '',
    },
    [UaopFlags.IncrementalVariableIntendedAssistanceOverlap]: {
        default: '',
    },
    [UaopFlags.IntendedTotalDelta]: {
        default: '',
    },
    [UaopFlags.IncrementalWashOverlap]: {
        default: '',
    },
    [UaopFlags.WindowedEntitlementLimit]: {
        default: '',
    },
};
